import { Wrench } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { Empty } from "~/foundation/components/Empty";

/**
 * A scaffolded settings section. The route, the policy gate, the navigation entry and the
 * chrome around it are real — only the body is pending. Saying so plainly beats shipping a
 * page that looks finished and does nothing.
 */
export function Placeholder({ note }: { note: string }) {
  const { t } = useTranslation();

  return (
    <div className="rounded-md border border-dashed border-divider">
      <Empty icon={Wrench} title={t("Not built yet")} message={t(note)} />
    </div>
  );
}
